// AOS Animation JS Script 
AOS.init({
  duration: 1000,
}); 
// Page Overflow Scroll Hidden Script
$(document).ready(function () {
  $(".navbar-toggle").click(function (e) {
    $("html").toggleClass("overflow-hidden");
  });
  headerscroll();
});
// Header Sticky Js
function headerscroll() {
  var headerheight = $("header").height();
  var scroll = $(window).scrollTop();
  if (scroll >= headerheight) {
    $("header").addClass("sticky");
  } else {
    $("header").removeClass("sticky");
  }
};
$(window).scroll(function () {
  headerscroll();
});

// Home page Banner slick Slider js
$('.banner-section').slick({
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  fade: true,
  cssEase: 'ease-in-out',
  autoplay: true,
  autoplaySpeed: 5000
});

// Catalouges Section Slick slider Js
$('.catalouge-slider').slick({
  centerMode: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  swipe: true,
  dots: false,
  autoplay: true,
  autoplaySpeed: 1200,
  infinite: true,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    }
  ]
  //adaptiveHeight: true,
});

// Catalouges Page Hero Slick slider Js
$('.our-catalogues-hero-slider').slick({
  centerMode: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  swipe: true,
  dots: false,
  // autoplay: true,
  // autoplaySpeed: 1300,
  infinite: true,
  swipeToSlide: true,
  //adaptiveHeight: true,
});

/*** Back to top btn Js ***/
if ($('#back-to-top').length) {
  var scrollTrigger = 150, // px
    backToTop = function () {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > scrollTrigger) {
        $('#back-to-top').addClass('show');
      } else {
        $('#back-to-top').removeClass('show');
      }
    };
  backToTop();
  $(window).on('scroll', function () {
    backToTop();
  });
  $('#back-to-top').on('click', function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: 0
    }, 700);
  });
}

// Our Collection Slider JS
$(document).ready(function() {
  var $item = 0,
    $itemNo = $(".hero figure").length;
  function transitionSlide() {
    $item++;
    if ($item > $itemNo - 1) {
      $item = 0;
    }
    $(".hero figure").removeClass("on");
    $(".hero figure")
      .eq($item)
      .addClass("on");
  }
  var $autoTransition = setInterval(transitionSlide, 3500);

  $(".hero figure").click(function() {
    clearInterval($autoTransition);
    $item = $(this).index();
    $(".hero figure").removeClass("on");
    $(".hero figure")
      .eq($item)
      .addClass("on");
    $autoTransition = setInterval(transitionSlide, 3500);
  });
});
// Select 2 Script
$(".custom-selectbox").select2({
    minimumResultsForSearch: -1
}); 
// Counter JS Included
(function( $ ){
  "use strict";

  $.fn.countUp = function( options ) {

    // Defaults
    var settings = $.extend({
        'time': 2000,
        'delay': 10
    }, options);

    return this.each(function(){

        // Store the object
        var $this = $(this);
        var $settings = settings;

        var counterUpper = function() {
            if(!$this.data('counterupTo')) {
                $this.data('counterupTo',$this.text());
            }
            var time = parseInt($this.data("counter-time")) > 0 ? parseInt($this.data("counter-time")) : $settings.time;
            var delay = parseInt($this.data("counter-delay")) > 0 ? parseInt($this.data("counter-delay")) : $settings.delay;
            var divisions = time / delay;
            var num = $this.data('counterupTo');
            var nums = [num];
            var isComma = /[0-9]+,[0-9]+/.test(num);
            num = num.replace(/,/g, '');
            var isInt = /^[0-9]+$/.test(num);
            var isFloat = /^[0-9]+\.[0-9]+$/.test(num);
            var decimalPlaces = isFloat ? (num.split('.')[1] || []).length : 0;

            // Generate list of incremental numbers to display
            for (var i = divisions; i >= 1; i--) {

                // Preserve as int if input was int
                var newNum = parseInt(Math.round(num / divisions * i));

                // Preserve float if input was float
                if (isFloat) {
                    newNum = parseFloat(num / divisions * i).toFixed(decimalPlaces);
                }

                // Preserve commas if input had commas
                if (isComma) {
                    while (/(\d+)(\d{3})/.test(newNum.toString())) {
                        newNum = newNum.toString().replace(/(\d+)(\d{3})/, '$1'+','+'$2');
                    }
                }

                nums.unshift(newNum);
            }

            $this.data('counterup-nums', nums);
            $this.text('0');

            // Updates the number until we're done
            var f = function() {
                $this.text($this.data('counterup-nums').shift());
                if ($this.data('counterup-nums').length) {
                    setTimeout($this.data('counterup-func'),delay);
                } else {
                    delete $this.data('counterup-nums');
                    $this.data('counterup-nums', null);
                    $this.data('counterup-func', null);
                }
            };
            $this.data('counterup-func', f);

            // Start the count up
            setTimeout($this.data('counterup-func'),delay);
        };

        // Perform counts when the element gets into view
        $this.waypoint(counterUpper, { offset: '100%', triggerOnce: true });
    });

  };

})( jQuery );

/*** Back to top btn Js ***/
if ($('#back-to-top').length) {
  var scrollTrigger = 150, // px
    backToTop = function () {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > scrollTrigger) {
        $('#back-to-top').addClass('show');
      } else {
        $('#back-to-top').removeClass('show');
      }
    };
  backToTop();
  $(window).on('scroll', function () {
    backToTop();
  });
  $('#back-to-top').on('click', function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: 0
    }, 700);
  });
}

